import { FindAProviderConfigModelBase } from "./FindAProviderConfigModel.base"


/* A graphql query fragment builders for FindAProviderConfigModel */
export { selectFromFindAProviderConfig, findAProviderConfigModelPrimitives, FindAProviderConfigModelSelector } from "./FindAProviderConfigModel.base"

export const EMPTY_FIND_A_PROVIDER_CONFIG = Object.freeze({
  __typename: "FindAProviderConfig",
  isAppointmentDateFilterEnabled: false,
  isAppointmentTimeFilterEnabled: false,
  isAcceptsOnlineBookingFilterEnabled: false,
  isDirectionsButtonEnabled: false,
  isLanguageFilterEnabled: false,
  isLoadAllLocationsButtonEnabled: false,
  isLoadAllLocationsEnabled: false,
  isProviderNameFilterEnabled: false,
  isShowOnlyClaimedAccountsEnabled: false,
  isShowProviderResultsEnabled: false,
  isSpecialtyFilterEnabled: false,
  allowedSpecialties: [],
  defaultSpecialty: null,
  partnerTagLabel: null,
})

export const DEFAULT_FIND_A_PROVIDER_CONFIG = Object.freeze({
  __typename: "FindAProviderConfig",
  isAppointmentDateFilterEnabled: true,
  isAppointmentTimeFilterEnabled: true,
  isAcceptsOnlineBookingFilterEnabled: true,
  isDirectionsButtonEnabled: true,
  isLanguageFilterEnabled: false,
  isLoadAllLocationsButtonEnabled: false,
  isLoadAllLocationsEnabled: false,
  isProviderNameFilterEnabled: true,
  isShowOnlyClaimedAccountsEnabled: false,
  isShowProviderResultsEnabled: false,
  isSpecialtyFilterEnabled: true,
  allowedSpecialties: [],
  defaultSpecialty: null,
  partnerTagLabel: null,
})

export function findAProviderConfigFor(partner) {
  if (partner === undefined) {
    return EMPTY_FIND_A_PROVIDER_CONFIG
  }

  if (partner === null) {
    return DEFAULT_FIND_A_PROVIDER_CONFIG
  }

  return partner.findAProviderConfig || EMPTY_FIND_A_PROVIDER_CONFIG
}

/**
 * FindAProviderConfigModel
 *
 * A Partners find a provider config
 */
export const FindAProviderConfigModel = FindAProviderConfigModelBase
